import { useCallback, useEffect, useRef } from "react";

interface UseLongPressOptions {
  ms: number;
  onLongPress: () => void;
}

interface UseLongPressHandlers {
  onMouseDown: () => void;
  onMouseUp: () => void;
  onMouseLeave: () => void;
  onTouchStart: () => void;
  onTouchEnd: () => void;
  onTouchCancel: () => void;
}

export const useLongPress = ({ ms, onLongPress }: UseLongPressOptions): UseLongPressHandlers => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const callbackRef = useRef(onLongPress);

  useEffect(() => {
    callbackRef.current = onLongPress;
  }, [onLongPress]);

  useEffect(() => {
    return () => {
      if(timerRef.current){
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const start = useCallback(() => {
    if(timerRef.current){
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      callbackRef.current();
      timerRef.current = null;
    }, ms);
  }, [ms]);

  const cancel = useCallback(() => {
    if(timerRef.current){
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  return {
    onMouseDown: start,
    onMouseUp: cancel,
    onMouseLeave: cancel,
    onTouchStart: start,
    onTouchEnd: cancel,
    onTouchCancel: cancel,
  };
};
